import React, { useEffect, useState } from "react";
import "./user-history.styles.scss";
import { ColumnType } from "antd/lib/table";
import CTable from "../../components/table/CTable";
import { IUserHistory } from "../../common/history.interface";
import HistoryApi from "../../api/history/history.api";
import { motion } from "framer-motion";

const UserHistory = () => {
    const [userHistories, setUserHistories] = useState<IUserHistory[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const pageSize = 10;

    const fetchUserHistories = () => {
        setLoading(true);
        HistoryApi.getAllUserHistory().subscribe(
            (data) => {
                setUserHistories(data);
                setTotalRecords(data.length);
                setLoading(false);
            },
            (error) => {
                console.error("Error fetching user histories", error);
                setLoading(false);
            }
        );
    };

    useEffect(() => {
        fetchUserHistories();
    }, []);

    const onChangePagination = (page: number) => {
        setCurrentPage(page);
    };

    const columns: ColumnType<IUserHistory>[] = [
        {
            title: "STT",
            render: (_, __, rowIndex) => (
                <div className="span-table" style={{ textAlign: "center" }}>
                    {pageSize * (currentPage - 1) + rowIndex + 1}
                </div>
            ),
            width: "5%",
        },
        {
            title: "Người dùng",
            render: (_, record) => (
                <div>{`${record.user.firstname}`}</div>
            ),
            width: "15%",
        },
        {
            title: "Email",
            render: (_, record) => (
                <div>{record.user.email}</div>
            ),
            width: "15%",
        },
        {
            title: "Tên sách",
            render: (_, record) => (
                <div>{record.book.name}</div>
            ),
            width: "20%",
        },
        {
            title: "Loại",
            dataIndex: "type",
            key: "type",
            width: "8%",
            render: (type) => type === "READ" ? "Đọc" : "Nghe",
            sorter: (a, b) => a.type.localeCompare(b.type),
        },
        {
            title: "Tiến độ",
            key: "progress",
            render: (_, record) => {
                if (record.type === "READ") {
                    return (
                        <div>
                            <div>{record.percent !== null ? `${record.percent}%` : "N/A"}</div>
                            <small style={{ color: "#666" }}>
                                {record.currentPage && record.totalPage 
                                    ? `${record.currentPage}/${record.totalPage} trang` 
                                    : ""}
                            </small>
                        </div>
                    );
                } else if (record.type === "LISTEN") {
                    const minutes = record.position ? Math.floor(record.position / 60) : 0;
                    const seconds = record.position ? Math.floor(record.position % 60) : 0;
                    return (
                        <div>
                            <div>{`${minutes}:${seconds.toString().padStart(2, '0')}`}</div>
                            <small style={{ color: "#666" }}>
                                {record.chapter ? `Chương ${record.chapter}` : ""}
                            </small>
                        </div>
                    );
                }
                return "N/A";
            },
            width: "15%",
            sorter: (a, b) => {
                if (a.type === "READ" && b.type === "READ") {
                    return (a.percent ?? -1) - (b.percent ?? -1);
                } else if (a.type === "LISTEN" && b.type === "LISTEN") {
                    return (a.position ?? -1) - (b.position ?? -1);
                }
                return a.type.localeCompare(b.type);
            },
        },
        {
            title: "Ngày cập nhật",
            dataIndex: "updatedAt",
            key: "updatedAt",
            render: (text) => new Date(text).toLocaleDateString("en-GB"),
            width: "12%",
            sorter: (a, b) => new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime(),
        },
    ];

    return (
        <motion.div
            className="user-history-main"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <div className="table-area">
                <CTable
                    tableMainTitle="Lịch sử hoạt động người dùng"
                    titleOfColumnList={columns}
                    data={userHistories}
                    totalRecord={totalRecords}
                    onChangePagination={onChangePagination}
                    pageSize={pageSize}
                    size={450}
                />
            </div>
        </motion.div>
    );
};

export default UserHistory;

